import { AxiosError } from 'axios';

const stringifyData = (data: unknown) => {
	if (typeof data === 'string') {
		return data;
	}

	try {
		return JSON.stringify(data);
	} catch {
		return String(data);
	}
};

export const getApiErrorMessage = (error: unknown, fallbackMessage: string) => {
	if (error instanceof AxiosError) {
		const responseData = error.response?.data;

		if (typeof responseData === 'string') {
			return responseData;
		}

		if (responseData && typeof responseData === 'object') {
			const message =
				'message' in responseData
					? responseData.message
					: 'error' in responseData
						? responseData.error
						: 'detail' in responseData
							? responseData.detail
							: null;

			if (typeof message === 'string' && message.trim()) {
				return message;
			}

			return stringifyData(responseData);
		}

		if (error.message) {
			return error.message;
		}
	}

	if (error instanceof Error) {
		return error.message;
	}

	if (typeof error === 'string') {
		return error;
	}

	return fallbackMessage;
};

export const createApiError = (
	error: unknown,
	fallbackMessage: string,
	logMessage = fallbackMessage,
) => {
	const message = getApiErrorMessage(error, fallbackMessage);

	console.error(message, logMessage, error);

	return new Error(message || fallbackMessage);
};
